import React from "react";
import { Alert, Box, Button } from "@mui/material";

interface WorkflowSilentStageNoticeProps {
  onReload: () => void;
}

/**
 * Conditional, web-service, email and finalize stages are SILENT: the engine runs them itself
 * inside start / advance and lands the case on the next stage a person acts on, so a real case
 * should never sit on one. If it ever does, there is nothing for the user to do here but reload.
 */
const WorkflowSilentStageNotice: React.FC<WorkflowSilentStageNoticeProps> = ({ onReload }) => (
  <>
    <Alert severity="info" className="workflow-run__alert--flush">
      This step runs automatically — the workflow engine moves the case on by itself.
    </Alert>
    <Box className="workflow-run__actions workflow-run__actions--end">
      <Button variant="outlined" color="secondary" onClick={onReload}>
        Reload
      </Button>
    </Box>
  </>
);

export default WorkflowSilentStageNotice;
